import { useCallback } from 'react';
import { DriveFile } from '../services/myDriveService';

const DRAG_TYPE = 'application/x-drive-file';

export function useFileDragDrop(
  currentPrefix: string,
  onMove: (fileId: number, newPath: string) => Promise<unknown>,
  onUploadFiles: (files: FileList) => Promise<void>,
) {
  const onDragStart = useCallback((e: React.DragEvent, file: DriveFile) => {
    e.dataTransfer.setData(DRAG_TYPE, JSON.stringify({ id: file.id, relative_path: file.relative_path }));
    e.dataTransfer.effectAllowed = 'move';
  }, []);

  const onDragOver = useCallback((e: React.DragEvent) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = e.dataTransfer.types.includes(DRAG_TYPE) ? 'move' : 'copy';
  }, []);

  const onDrop = useCallback(async (e: React.DragEvent, targetFolder: DriveFile | null) => {
    e.preventDefault();
    e.stopPropagation();

    // 外部拖入 → 上傳
    if (e.dataTransfer.files.length > 0) {
      await onUploadFiles(e.dataTransfer.files);
      return;
    }

    // 內部拖移
    const raw = e.dataTransfer.getData(DRAG_TYPE);
    if (!raw) return;
    const { id, relative_path } = JSON.parse(raw) as { id: number; relative_path: string };
    const basename = relative_path.split('/').pop()!;
    const targetPath = targetFolder
      ? `${targetFolder.relative_path}/${basename}`
      : currentPrefix ? `${currentPrefix}${basename}` : basename;

    if (targetPath !== relative_path) {
      await onMove(id, targetPath);
    }
  }, [currentPrefix, onMove, onUploadFiles]);

  return { onDragStart, onDragOver, onDrop };
}
